import React from 'react';
import { bool, func, node, string } from 'prop-types';
import classNames from 'classnames';

import ChevronButton from '../ChevronButton/ChevronButton';

import css from './PricingDetailsCard.module.css';

const PricingDetailsCard = ({ ariaLabel, children, className, isExpanded, onToggle, summary }) => {
  return (
    <div className={classNames(css.root, className)}>
      <ChevronButton
        className={classNames(css.summaryHeader, {
          [css.summaryHeaderExpanded]: isExpanded,
        })}
        onClick={onToggle}
        isExpanded={isExpanded}
        ariaLabel={ariaLabel}
      >
        {summary}
      </ChevronButton>

      <div
        className={classNames(css.detailsContainer, {
          [css.detailsExpanded]: isExpanded,
        })}
      >
        <div className={css.detailsDivider} />
        {children}
      </div>
    </div>
  );
};

PricingDetailsCard.defaultProps = {
  ariaLabel: 'Toggle pricing details',
  className: null,
};

PricingDetailsCard.propTypes = {
  ariaLabel: string,
  children: node.isRequired,
  className: string,
  isExpanded: bool.isRequired,
  onToggle: func.isRequired,
  summary: node.isRequired,
};

export default PricingDetailsCard;
